export default __webpack_public_path__ + "static/media/icon_info_warning_dialog.a3168ce2.svg";